import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';
import { Icon } from './Icon';
import { IconProps } from './types/IconProps';

export const HomeOutlinedIcon = (props: IconProps): ReactNode => (
  <Icon {...props} testId={locator.components.icon.homeOutlined}>
    <path d="m12 5.69 5 4.5V18h-2v-6H9v6H7v-7.81zM12 3 2 12h3v8h6v-6h2v6h6v-8h3z" />
  </Icon>
);
